import { Toaster as Sonner, toast } from "sonner"
import { useAuth } from "../../contexts/AuthContext"
import { themes } from "../../themes"

// docs/futuregoals.md FG-8: this wrapper used to read `useTheme()` from
// next-themes, but nothing in the app ever calls next-themes' `setTheme` —
// that provider is permanently stuck on its `defaultTheme="system"`. And
// separately, this wrapper was never actually imported anywhere (App.js
// rendered the raw `sonner` package's `<Toaster>` directly), so toasts were
// getting sonner's own hardcoded default regardless. Now sourced from the
// real theme system (AuthContext) via the same `className.includes('dark')`
// check the theme-apply effect itself already uses, so a toast's light/dark
// styling always matches whichever of the 10 real themes is actually applied.
const Toaster = ({
  ...props
}) => {
  const { theme: themeKey } = useAuth()
  const isDark = themes[themeKey]?.className?.includes('dark') ?? false
  const mode = isDark ? 'dark' : 'light'

  return (
    <Sonner
      theme={mode}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
